import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { UserSelector } from '@ui/UserSelector';
import { coreActions, ResponsibilityType } from '@sonar-software/sonar-core';
import { useAction, useOnMount, useSonarObjectReference } from '@hooks';
export const SonarObjectOwner = ({ getPopupContainer, isSpreadsheet, sonarObjectId, withLatest }) => {
    var _a, _b;
    const users = (_b = (_a = useSonarObjectReference(sonarObjectId)) === null || _a === void 0 ? void 0 : _a.users) !== null && _b !== void 0 ? _b : [];
    const getBusinessContextOwner = useAction(coreActions.requestGetCoreSonarObjectsUsers);
    const updateBusinessContextOwner = useAction(coreActions.requestPutCoreSonarObjectsUsers);
    useOnMount(() => {
        if (withLatest) {
            getBusinessContextOwner({ sonarObjectId });
        }
    });
    const handleChange = (userId) => {
        const newUsers = [];
        if (userId) {
            newUsers.push({
                responsibilityType: ResponsibilityType.Owner,
                userId
            });
        }
        updateBusinessContextOwner({
            sonarObjectId,
            users: newUsers
        });
    };
    const owner = users.find((user) => user.responsibilityType === ResponsibilityType.Owner);
    return (React.createElement(UserSelector, { allowClear: true, avatar: true, getPopupContainer: getPopupContainer, isSpreadsheet: isSpreadsheet, onChange: handleChange, placeholder: PLACEHOLDERS_COPY.ADD_OWNER, value: owner === null || owner === void 0 ? void 0 : owner.userId }));
};
